import dayjs from "dayjs";
import type { TooltipProps } from "recharts";
import type {
	NameType,
	ValueType,
} from "recharts/types/component/DefaultTooltipContent";

interface ChartDataPoint {
	name: string;
	date: string;
	timing: string;
	[key: string]: string | number;
}

export function ChartTooltip({
	active,
	payload,
	label,
}: TooltipProps<ValueType, NameType>) {
	if (!active || !payload || !payload.length) {
		return null;
	}

	const dataPoint = payload[0]?.payload as ChartDataPoint | undefined;
	if (!dataPoint) return null;

	return (
		<div className="bg-background shadow-sm p-2 border rounded-lg">
			<div className="gap-2 grid grid-cols-2">
				<div className="flex flex-col">
					<span className="text-[0.70rem] text-muted-foreground uppercase">
						Timing
					</span>
					<span className="font-bold text-muted-foreground">
						{dataPoint.timing}
					</span>
				</div>
				<div className="flex flex-col">
					<span className="text-[0.70rem] text-muted-foreground uppercase">
						Date
					</span>
					<span className="font-bold text-muted-foreground">
						{dayjs(dataPoint.date).format("MMM D, YYYY")}
					</span>
				</div>
			</div>
			{payload.map((entry) => (
				<div key={entry.name} className="flex flex-col mt-2">
					<span className="text-[0.70rem] text-muted-foreground uppercase">
						{entry.name}
					</span>
					<span className="font-bold text-2xl">
						{Number(entry.value).toFixed(2)}
					</span>
				</div>
			))}
		</div>
	);
}
